var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOutlookLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79,
    height: 73,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#C)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.368 38.325a1.75 1.75 0 0 0-.835-1.506h-.009l-.033-.018-27.155-16.097a3.68 3.68 0 0 0-.364-.217 3.64 3.64 0 0 0-3.343 0 3.7 3.7 0 0 0-.364.217L19.109 36.801l-.033.018c-.83.517-1.084 1.61-.568 2.441a1.77 1.77 0 0 0 .61.594l27.155 16.096c.118.079.239.151.364.217a3.64 3.64 0 0 0 3.343 0 4.07 4.07 0 0 0 .364-.217L77.5 39.854a1.75 1.75 0 0 0 .867-1.529z",
    fill: "#0a2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.275 27.578h17.82v16.357h-17.82V27.578zM74.723 10.95V3.467A3.39 3.39 0 0 0 71.418 0H25.174a3.39 3.39 0 0 0-3.304 3.467v7.483l27.338 7.3 25.515-7.3z",
    fill: "#0364b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.87 10.95h18.225v16.425H21.87V10.95z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.32 10.95H40.095v16.425L58.32 43.8h16.403V27.375L58.32 10.95z",
    fill: "#28a8ea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.095 27.375H58.32V43.8H40.095V27.375z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.095 43.8H58.32v16.425H40.095V43.8z",
    fill: "#0364b8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.275 43.935h17.82v14.87h-17.82v-14.87z",
    fill: "#14447d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.32 43.8h16.402v16.425H58.32V43.8z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.533 39.754l-.035.018-27.155 15.294-.364.204a3.78 3.78 0 0 1-1.473.365l-1.483-.869a3.7 3.7 0 0 1-.364-.21l-27.52-15.728h-.013l-.9-.504v30.959A3.74 3.74 0 0 0 21.985 73h52.681c.031 0 .058-.015.091-.015.436-.028.865-.118 1.276-.266.177-.075.349-.164.512-.266.122-.069.332-.221.332-.221.934-.692 1.486-1.784 1.491-2.947V38.325c-.001.592-.32 1.138-.835 1.429z",
    fill: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M76.91 38.203v1.898L48.515 59.678 19.118 38.842c0-.01-.008-.018-.018-.018l-2.697-1.624V35.83l1.112-.018 2.351 1.351.055.018.201.128 27.702 15.823 1.057.62.291-.109c.055-.037 27.429-15.458 27.429-15.458l.31.018z",
    fill: "#0a2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.533 39.754l-.035.02-27.155 15.294-.364.204c-1.055.516-2.288.516-3.343 0a4.13 4.13 0 0 1-.364-.204L19.116 39.774l-.033-.02c-.524-.285-.853-.832-.858-1.429v30.959c.013 2.065 1.695 3.729 3.758 3.716H74.61c2.062.013 3.745-1.65 3.758-3.716V38.325c-.001.592-.32 1.138-.835 1.429z",
    fill: "#1490df"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M50.738 54.841l-.406.228c-.118.075-.239.144-.364.206a3.77 3.77 0 0 1-1.433.38L58.867 67.89l18.023 4.349a3.72 3.72 0 0 0 1.143-1.429L50.738 54.841z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M52.579 53.805l-2.247 1.265a3.97 3.97 0 0 1-.364.206 3.77 3.77 0 0 1-1.433.38l4.841 13.365 23.519 3.214a3.69 3.69 0 0 0 1.473-2.949v-.4l-25.788-15.08z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.034 73h52.57c.809.004 1.598-.252 2.251-.73l-29.834-17.5a3.71 3.71 0 0 1-.364-.21l-27.52-15.728h-.013l-.898-.507v30.853c-.002 2.109 1.703 3.82 3.809 3.822z",
    fill: "#28a8ea"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M43.74 17.945v38.927c-.003 1.365-.832 2.592-2.096 3.102-.392.169-.813.256-1.239.256h-22.18V16.425h3.645V14.6h18.535a3.35 3.35 0 0 1 3.335 3.345z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.917 19.77v38.927c.005.441-.089.877-.273 1.277a3.32 3.32 0 0 1-3.062 2.075H18.225V16.425h20.357c.529-.005 1.05.127 1.513.383a3.32 3.32 0 0 1 1.822 2.962z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M41.917 19.77v35.277c-.009 1.843-1.495 3.337-3.335 3.352H18.225V16.425h20.357c.529-.005 1.05.127 1.513.383a3.32 3.32 0 0 1 1.822 2.962z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M40.095 19.77v35.277c-.002 1.846-1.492 3.343-3.335 3.352H18.225V16.425H36.76a3.34 3.34 0 0 1 3.335 3.343z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.341 16.425h33.414c1.845 0 3.341 1.498 3.341 3.345v33.46c0 1.847-1.496 3.345-3.341 3.345H3.341C1.496 56.575 0 55.077 0 53.23V19.77c0-1.848 1.496-3.345 3.341-3.345z",
    fill: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.441 30.456c.823-1.757 2.152-3.227 3.816-4.221 1.843-1.056 3.941-1.583 6.063-1.522 1.967-.043 3.908.457 5.611 1.444a9.64 9.64 0 0 1 3.712 4.033 13.03 13.03 0 0 1 1.301 5.931c.043 2.145-.415 4.27-1.34 6.205a9.87 9.87 0 0 1-3.827 4.174 11.15 11.15 0 0 1-5.821 1.482 10.96 10.96 0 0 1-5.736-1.46c-1.615-.957-2.921-2.36-3.762-4.04a12.72 12.72 0 0 1-1.316-5.86 14.13 14.13 0 0 1 1.296-6.165zm4.068 9.91c.439 1.111 1.184 2.074 2.147 2.778a5.6 5.6 0 0 0 3.353 1.011 5.87 5.87 0 0 0 3.579-1.044 6.05 6.05 0 0 0 2.085-2.778 10.8 10.8 0 0 0 .665-3.874 11.81 11.81 0 0 0-.627-3.924c-.379-1.14-1.081-2.146-2.019-2.894a5.54 5.54 0 0 0-3.548-1.095 5.78 5.78 0 0 0-3.432 1.02 6.37 6.37 0 0 0-2.187 2.801c-.995 2.573-1 5.425-.015 8.003l-.002-.004z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.32 10.95h16.402v16.425H58.32V10.95z",
    fill: "#50d9ff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 48.296,
    y1: 38.325,
    x2: 48.296,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35b8f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28a8ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 6.965,
    y1: 13.811,
    x2: 33.184,
    y2: 59.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107ad5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a63c9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "C"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h78.368v73H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookLogo);
export default __webpack_public_path__ + "static/media/OutlookLogo.3eda4b4111853897fe4317fbbe115e4f.svg";
export { ForwardRef as ReactComponent };